import { useEffect } from 'react';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/solid';
import { useNavigate, useSearchParams } from 'react-router-dom';

import useGlobalStore from 'hooks/useGlobalStore';

function SearchInput() {
    const navigate = useNavigate();
    const { searchQuery, setAutocompleteOpen, setSearchQuery } = useGlobalStore();
    const [searchParams] = useSearchParams();
    const urlSearchQuery = searchParams.get('query');
    const { pathname } = window.location ?? {};

    useEffect(() => {
        if (urlSearchQuery) {
            const placeholderQuery = searchQuery || urlSearchQuery;
            setSearchQuery(placeholderQuery);
        } else {
            setSearchQuery('');
        }
    }, [urlSearchQuery]);

    const clearSearchQuery = () => {
        setSearchQuery('');
        setAutocompleteOpen(false);
    };

    const handleSubmitSearch = (e) => {
        e.preventDefault();
        if (pathname.includes('search') || pathname.includes('brand')) {
            window.location.href = `/shop/search?query=${searchQuery}`;
        } else {
            navigate(`/shop/search?query=${searchQuery}`);
            setAutocompleteOpen(false);
        }
    };

    const handleUpdateQuery = (e) => {
        setSearchQuery(e.target.value);
    };

    return (
        <div className="flex max-w-xs items-center gap-5 border-b-2 border-black">
            <div className="min-w-max">
                <MagnifyingGlassIcon width={20} />
            </div>
            <form onSubmit={handleSubmitSearch} className="w-full overflow-hidden">
                <input
                    className="w-full outline-none"
                    name="search"
                    id="search"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleUpdateQuery}
                    onFocus={() => setAutocompleteOpen(true)}
                />
            </form>
            {searchQuery !== '' && (
                <button type="button" className="cursor-pointer" onClick={clearSearchQuery}>
                    <XMarkIcon width={20} />
                </button>
            )}
        </div>
    );
}

export default SearchInput;
